import { TableContainer, Table, TableHead, TableRow, TableCell, Grid, Skeleton, Stack, Box } from '@mui/material';
import { TableBody } from 'mui-datatables';

export const ChatSkeleton = () => (
  <Grid xs={12} md={8} sx={{ height: '100%' }}>
    <Box sx={{ height: '85vh', width: '100%', padding: 2, border: 1, borderColor: 'divider' }}>
      {[...Array(2)].map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: 2,
            justifyContent: 'flex-start',
          }}
        >
          <Box sx={{ width: '100%' }}>
            <SkeletonStamp />
            <SkeletonLinkPreview />
            <SkeletonChatBubble />
          </Box>
        </Box>
      ))}
    </Box>
  </Grid>
);

const SkeletonStamp = ({ isOwnMessage }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: isOwnMessage ? 'flex-end' : 'flex-start' }}>
    <Skeleton
      variant='text'
      width='30%'
      height={20}
      sx={{
        marginBottom: 1,
      }}
    />
  </Box>
);

const SkeletonChatBubble = ({ isOwnMessage }) => (
  <Box
    sx={{
      position: 'relative',
      borderRadius: 3,
      backgroundColor: isOwnMessage ? '#EEF5FF' : '#EEF5FF',
      padding: '8px 12px',
      width: '30vw',
      maxWidth: '85%',
      wordWrap: 'break-word',
      marginLeft: isOwnMessage ? 'auto' : 0,
      marginRight: isOwnMessage ? 0 : 'auto',
      borderTopRightRadius: isOwnMessage ? 0 : null,
      borderTopLeftRadius: isOwnMessage ? null : 0,
      boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
      marginBottom: 1,
    }}
  >
    <Skeleton variant='text' width='100%' height={40} />
  </Box>
);

export const SkeletonLinkPreview = ({ isOwnMessage }) => (
  <Box
    sx={{
      mt: 1,
      border: '1px solid #ddd',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      width: '300px',
      marginBottom: 2,
      marginLeft: isOwnMessage ? 'auto' : 0,
      marginRight: isOwnMessage ? 0 : 'auto',
      borderTopRightRadius: isOwnMessage ? 0 : null,
      borderTopLeftRadius: isOwnMessage ? null : 0,
    }}
  >
    <Skeleton variant='rectangular' width={300} height={150} />
    <Box sx={{ padding: '8px' }}>
      <Skeleton variant='text' width='80%' />
      <Skeleton variant='text' width='60%' sx={{ mt: 0.5 }} />
    </Box>
  </Box>
);

export const GiftPreviewSkeleton = () => {
  <Grid xs={4} sx={{ height: '100%' }}>
    <Stack>
      <Skeleton variant='rectangular' sx={{ width: '100%' }} />
    </Stack>
  </Grid>;
};

export const GiftSkeletonTable = () => {
  const rowCount = 9; // Number of skeleton rows
  const columnCount = 5; // Adjust based on your table's column count

  return (
    <Grid xs={8}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {[...Array(5)].map((_, index) => (
                <TableCell key={index}>
                  <Skeleton variant='text' width='50%' height={30} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: 5 }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {Array.from({ length: 8 }).map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    {colIndex === 0 ? (
                      <Grid gap={2} display={'flex'} flexDirection={'row'} direction={'row'}>
                        <Skeleton variant='circular' width={40} height={40} />
                        <Skeleton variant='text' width={'50%'} height={40} />
                      </Grid>
                    ) : (
                      <Skeleton variant='text' width='80%' height={30} />
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};
